import { render, staticRenderFns } from "./ShipmentTypeForm.vue?vue&type=template&id=e42b4226&scoped=true&"
import script from "./ShipmentTypeForm.vue?vue&type=script&lang=js&"
export * from "./ShipmentTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentTypeForm.vue?vue&type=style&index=0&id=e42b4226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42b4226",
  null
  
)

export default component.exports